import { add, format, isAfter } from 'date-fns';
import type { Duration } from 'date-fns';

interface GetTimeRangeProps {
  end: Date;
  increment: number;
  outputFormat: string;
  start: Date;
  unit: keyof Duration;
}

export const getTimeRange = ({
  start,
  end,
  increment,
  unit,
  outputFormat,
}: GetTimeRangeProps): string[] => {
  const range: string[] = [];
  let current = start;

  while (!isAfter(current, end)) {
    range.push(format(current, outputFormat));
    current = add(current, { [unit]: increment });
  }

  return range;
};
